import React from 'react';
import clsx from 'clsx';
import {useAuthenticate} from '@netx/core-auth-next/hooks/useAuthenticate';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import {
	loggedInAsBannerClasses,
	getLoggedInAsBannerUtilityClass,
	LoggedInAsBannerClasses,
	LOGGED_IN_AS_BANNER_CLASS_NAME,
} from './loggedInAsBannerClasses';
import {i18n} from '@netx/core/i18n';
import {Typography} from '@mui/material';
import {useCurrentUser} from '../../store/currentUser';
import {IconButton} from '@netx/core-components/IconButton';
import {faTimes} from '@fortawesome/pro-solid-svg-icons';
import {Alert} from '@netx/core-components/Alert';

type LoggedInAsBannerOwnerState = WithClasses<LoggedInAsBannerClasses, {}>;

const useUtilityClasses = (ownerState: LoggedInAsBannerOwnerState) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(slots, getLoggedInAsBannerUtilityClass, classes);
};

const LoggedInAsBannerRoot = styled(Alert, {
	name: LOGGED_IN_AS_BANNER_CLASS_NAME,
	slot: 'Root',
})(({theme}) => ({
	width: '100%',
}));

export type LoggedInAsBannerProps = WithClasses<LoggedInAsBannerClasses, {}>;

export const LoggedInAsBannerPrimitive = ({
	classes: _classes,
	className,
	...props
}: LoggedInAsBannerProps) => {
	const {authenticatedAsOtherUser} = useAuthenticate();

	const classes = useUtilityClasses({
		classes: _classes,
		className,
	});

	const {user} = useCurrentUser();

	if (!authenticatedAsOtherUser) return null;

	return (
		<LoggedInAsBannerRoot
			className={clsx(classes.root, className)}
			noWrap
			severity="info"
			action={
				<IconButton
					icon={faTimes}
					label={i18n.t('i18n.logout')}
					size="small"
					onClick={() => {
						window.location.reload();
					}}
				/>
			}
		>
			<Typography variant="caption" noWrap>
				{i18n.t('i18n.loggedInAs')} {user.name1} {user.name3} (
				{user.email})
			</Typography>
		</LoggedInAsBannerRoot>
	);
};

export const LoggedInAsBanner = LoggedInAsBannerPrimitive;

export default LoggedInAsBanner;
